export default {
	timezones: [],
	list: [],
}



// WEBPACK FOOTER //
// ./src/store/cliente/state.js